// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LineNumbers {\n  padding: 1em 0.5em 1em 1em;\n  width: 3.5em;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  font-family: 'Inconsolata', 'Roboto Mono', monospace;\n  background: #292929;\n  border-right: 1px solid #5c5c5c;\n  font-size: 14px;\n  line-height: 21px;\n  box-sizing: border-box;\n  box-shadow: inset 0 4px 6px -2px #000;\n}\n.LineNumbers__number {\n  display: block;\n  color: #a9a9a9;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
